import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  z-index: 1;
  width: 100%;
  min-width: max-content;
  overflow: visible;

  .loading-login {
    display: flex;
    align-items: center;
    height: 80px;
    width: 100%;
    justify-content: center;

    .logo {
      animation: loadingHeart infinite 1s;
      right: 20px;
      bottom: 20px;
      width: 60px;
    }

    .btn-text {
      color: #001f5b;
      font-size: 20px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
    }
  }

  @keyframes loadingHeart {
    0% {
      opacity: 1;
      width: 62px;
    }

    100% {
      opacity: 1;
      width: 60px;
    }
  }
`

export const ConfirmTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
export const ContentMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: max-content;
  padding-top: 10px;
  color: #0f172a;

  .header {
    > p {
      color: #001842 !important;
      font-weight: 700;
      font-size: 15px;
      margin-bottom: 8px;
      font-family: 'Montserrat', sans-serif;
    }
  }

  .section {
    font-size: 16px;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    color: #0f172a;

    .header {
      > p {
        color: #001842 !important;
        font-weight: 700;
        font-size: 15px;
        margin-bottom: 8px;
        font-family: 'Montserrat', sans-serif;
      }
    }

    .left {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 0 20px 0;
      gap: 16px;
      border-bottom: solid rgba(181, 180, 180, 0.46) 1px;

      .left-header {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 120px;
        min-width: 120px;

        .info-header {
          width: 100%;
          font-size: 14px;
          font-weight: 700;
          color: #1e293b !important;
          font-family: 'Montserrat', sans-serif;
        }
      }

      .info {
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;
        gap: 8px;
        padding: 0;
        justify-content: space-between;

        .right {
          display: flex;
          flex-direction: column;
          width: 45px;
          min-width: 45px;
          height: 100%;
          position: relative;
          gap: 15px;
          justify-content: center;
          align-items: center;

          div {
            display: flex;
          }
        }
      }

      @media (max-width: 1400px) {
        .info {
          white-space: nowrap;
          flex-wrap: nowrap;
          padding-bottom: 8px;
          gap: 8px;
        }

        .info .right {
          min-width: 45px;
          max-width: 45px;
        }
      }
    }
  }
`

export const HoverContent = styled.div`
  display: flex;
  height: 80px;
  padding: 10px;
  width: 180px;
  flex-direction: column;
  color: #ffffff;
  font-size: 12px;
  justify-content: center;
  background: linear-gradient(to right, #ebebebff, #e6e6e6ff, #f3f5f8ff);
  box-shadow: 3px 3px 10px 2px rgba(0, 27, 75, 0.24);
  border-radius: 20px;
`
